import { getClientAppUrl } from './client-credentials';

export interface ShareableExercise {
  name: string;
  sets: string;
  reps: string;
  restSeconds?: string;
  notes?: string;
}

function formatExerciseLine(exercise: ShareableExercise, index: number): string {
  const name = exercise.name.trim();
  const sets = exercise.sets.trim();
  const reps = exercise.reps.trim();
  const rest = exercise.restSeconds?.trim();
  const notes = exercise.notes?.trim();

  let line = `${index}. ${name}`;

  const details: string[] = [];
  if (sets && reps) {
    details.push(`${sets}×${reps}`);
  } else if (sets) {
    details.push(sets);
  } else if (reps) {
    details.push(reps);
  }
  if (rest) {
    details.push(`отдых ${rest}с`);
  }
  if (details.length > 0) {
    line += ` — ${details.join(', ')}`;
  }

  if (notes) {
    line += `\n   ${notes}`;
  }

  return line;
}

export function formatTrainingPlanText(
  name: string,
  exercises: ShareableExercise[],
): string {
  const planName = name.trim() || 'План тренировки';
  const filled = exercises.filter((ex) => ex.name.trim() !== '');

  const lines = [`План: ${planName}`, ''];

  if (filled.length === 0) {
    lines.push('(упражнения не указаны)', '');
  } else {
    filled.forEach((ex, i) => {
      lines.push(formatExerciseLine(ex, i + 1));
    });
    lines.push('');
  }

  lines.push(`Приложение: ${getClientAppUrl()}`);
  return lines.join('\n');
}
